import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../hooks";
import Banner from "../layout/Banner";
import ForgotMyPasswordForm from "./ForgotMyPasswordForm";

export default function ForgotMyPassword() {
  const { user, isAuthenticated } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (user || isAuthenticated) {
      navigate("/");
    }
  }, [navigate, user, isAuthenticated]);

  return (
    <>
      <div className="w-full h-screen bg-off-white">
        {/* Forgot my password form */}
        <ForgotMyPasswordForm />

        {/* Alert banner */}
        <Banner />
      </div>
    </>
  );
}
